module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABWklEQVRIS+2WPUvDUBSGn5OriDUI4uDPcHFW+0u0gzR+gOKim6iTDqJgtU5+gKub/goXdzvVyUkwFBWTIw6FtLbNbZIqSLPmvOe5Oe/JOVf45UeaeXpGzlemUByrsxj0c5CHsQIvNvE/gH6ZQ4VVG3EkpvIRkB9fphqnawU8V5iPE0bevwNDCpUBw2xugadO2vRAZRdhBpi2gaYGqrLxFnIybLi1gWYCHF1k/7mEawPNDPjtWxSK8Ggc8s2epgYCOyileqMEimscboBJRzgdKbIUbaIsgG2bUuDC9Sj0gd3++NmWVIRLAg6sJo9hXZW5emwyD4Xj0LBlA3QCtlFW0gFtSG1iEn2hQA1pXD2qGGAi7ixJgXuux2Zz8tcy2ivgHcJ1Q3LBaMhVT4BxSWN2X3/SgF/mbyfNv/QwyTWxZSEEjlyPtY77sOuLcLuaC6Er3EuRWkdgGs9stF/19sUdTCPAPAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/top_icon_device_sel.png
// module id = 0saJ
// module chunks = 19